<app-label>{{ passwordRequiresLabel }}</app-label>
<ul>
  <ng-container *ngFor="let validator of validators">
    <app-form-feedback-item [fail]="isFailing(validator)" *ngIf="validator !== 'required'">
      {{ translatedValidators[validator] }}
    </app-form-feedback-item>
  </ng-container>
</ul>
